import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { OnboardingProps } from "../common";
import * as styles from "./nav-reorganization-modal.module.css";

const NAV_REORGANIZATION_VIDEO_URL =
  "https://assets.getredo.com/nav-onboarding/nav-reorganization.mp4";

export const NavReorganizationModal = memo(function NavReorganizationModal({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  return (
    <RedoModal
      modalSize="md"
      onModalCloseRequested={handleDismiss}
      primaryButton={{ text: "Got it", onClick: handleComplete, size: "sm" }}
      title="Your sidebar has a new look"
    >
      <Flex dir="column" gap="lg">
        <video
          autoPlay
          className={styles.image}
          loop
          muted
          playsInline
          src={NAV_REORGANIZATION_VIDEO_URL}
        />
        <Flex dir="column" gap="sm">
          <Text fontSize="sm" fontWeight="semibold">
            A new way to navigate
          </Text>
          <Text fontSize="sm" textColor="secondary">
            We've redesigned your sidebar into three clear sections: your core
            tools, active products, and new products to explore. Plus,
            Operations is now two dedicated spaces – Returns and Shipping – so
            you can find what you need faster.
          </Text>
        </Flex>
        <Flex dir="column" gap="sm">
          <Text fontSize="sm" fontWeight="semibold">
            Make it yours
          </Text>
          <Text fontSize="sm" textColor="secondary">
            Resize the sidebar to switch between icons and full labels and drag
            your products into the order that works best for you.
          </Text>
        </Flex>
      </Flex>
    </RedoModal>
  );
});
